import { DesktopPage } from '@/domain/mitarbeiter/pages/rotationsplan/overview/DesktopPage';
import { MobilePage } from '@/domain/mitarbeiter/pages/rotationsplan/overview/MobilePage';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';

export function Page({ view }: { view: View }) {
  return (
    <>
      <div className="hidden md:block md:flex-col md:gap-8 md:p-4 md:w-screen lg:p-10 2xl:max-w-screen-2xl 2xl:mx-auto">
        <DesktopPage view={view} />
      </div>
      <div className="block md:hidden">
        <MobilePage view={view} />
      </div>
    </>
  );
}
